import React from "react";

const TeamSection = () => {
  const team = [
    {
      name: "Saurabh Jain",
      role: "Strategy & Growth",
      img: "https://via.placeholder.com/300x400", // Replace with real image
    },
    {
      name: "Shubham",
      role: "Operations & Insights",
      img: "https://via.placeholder.com/300x400", // Replace with real image
    },
  ];

  return (
      <div className="team-section">
        <div className="container">
          <h1 className="about-sub-heading text-center mb-5">Meet the Team</h1>
          
          <div className="row justify-content-center g-4">
            {team.map((member, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                <div className="team-card">
                  <div className="card-gradient"></div>
                  <div className="card-content">
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-role">{member.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
  );
};

export default TeamSection;
